import { render } from "./EnfantsEtAdolescentsResume.vue?vue&type=template&id=f1b428ba"
import script from "./EnfantsEtAdolescentsResume.vue?vue&type=script&lang=js"
export * from "./EnfantsEtAdolescentsResume.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__